<template>
  <div>
    <v-form>
      <p class="mb-3">
        What are the two possible products for the aldol condensation (NOT double condensation)
        between benzaldehyde and ethylmethylketone? Select from the options listed below.
      </p>

      <v-simple-table>
        <v-row v-for="(part, partIndex) in optionsShuffled" :key="part">
          <v-col v-for="(option, index) in part" :key="option.value">
            <v-card outlined>
              <v-checkbox
                :id="'checkbox' + (index + partIndex)"
                v-model="inputs.studentAnswers"
                :value="option.value"
                class="pl-0 mb-n4 mt-0"
              />
              <label :for="'checkbox' + (index + partIndex)">
                <img :src="option.img" alt="" width="100%" class="pl-3" />
              </label>
            </v-card>
          </v-col>
        </v-row>
      </v-simple-table>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import {seededShuffle} from '@/courses/utils/seededShuffle';
import {prefixPublicAsset} from '@/common/plugins/public-asset-plugin';

export default {
  name: 'ChemUCI_51LPPL7_Q9',
  components: {StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        studentAnswers: [],
      },
      options: [
        {img: prefixPublicAsset('/img/assignments/UCI_prelab7_Q9_optionA.png'), value: 'a'},
        {img: prefixPublicAsset('/img/assignments/UCI_prelab7_Q9_optionB.png'), value: 'b'},
        {img: prefixPublicAsset('/img/assignments/UCI_prelab7_Q9_optionC.png'), value: 'c'},
        {img: prefixPublicAsset('/img/assignments/UCI_prelab7_Q9_optionD.png'), value: 'd'},
        {img: prefixPublicAsset('/img/assignments/UCI_prelab7_Q9_optionE.png'), value: 'e'},
        {img: prefixPublicAsset('/img/assignments/UCI_prelab7_Q9_optionF.png'), value: 'f'},
        {img: prefixPublicAsset('/img/assignments/UCI_prelab7_Q9_optionG.png'), value: 'g'},
        {img: prefixPublicAsset('/img/assignments/UCI_prelab7_Q9_optionH.png'), value: 'h'},
        {img: prefixPublicAsset('/img/assignments/UCI_prelab7_Q9_optionI.png'), value: 'i'},
      ],
    };
  },
  computed: {
    seed() {
      return this.$inertia.getSeed();
    },
    optionsShuffled() {
      let shuffledOptions = seededShuffle(this.options, this.seed);
      return {
        part1: [shuffledOptions[0], shuffledOptions[1], shuffledOptions[2]],
        part2: [shuffledOptions[3], shuffledOptions[4], shuffledOptions[5]],
        part3: [shuffledOptions[6], shuffledOptions[7], shuffledOptions[8]],
      };
    },
  },
};
</script>
